import React, { useState } from 'react'

import { Modal } from 'react-bootstrap'

import RequestService from "../../services/request.service";

import { SERVER_ } from  '../../config';

import { toast } from 'react-toastify'


const ModalAnexos = (props) => {

	const { uuid_tramite, onHideModalAnexos, showModalAnexos } = props

	const [ anexos_digitales, setAnexos ] = useState<any>([])

	const cargarAnexos = async ()=>{
		try{
			let res = await RequestService.getEndPoint('mesa_tencion/anexos_digitales/'+uuid_tramite)
			setAnexos(res.data)
		}
		catch(e){
			toast.error('Error al cargar los anexos')
		}
	}

  React.useEffect(() => {
    cargarAnexos()
  }, []);

const [ anexo_visualizar, setAnexoVisualizar ] = useState<string>('')
const [ anexo_para_subir, setAnexoSubir ] = useState<string>('')
const [ anexo_archivo_subir, setArchivoSubir ] = useState<any>('')

// const setAnexoVer = (anexo:string)=>{
//   setAnexoVisualizar(anexo)
// }

	return (

			<React.Fragment>

		      <Modal size="lg" show={showModalAnexos} onHide={onHideModalAnexos}>
		        <Modal.Header closeButton>
		          <Modal.Title>Anexos Digitales</Modal.Title>
		        </Modal.Header>
		        <Modal.Body>
		        	
				

				{
					// JSON.stringify(uuid_tramite)
				}


					<div className="form-floating">
					  <select className="form-select" value={anexo_visualizar} onChange={(e)=>{ setAnexoVisualizar(e.target.value) }} id="floatingSelect" aria-label="Floating label select example">
					  <option disabled={anexo_visualizar===''?false:true} value="">Selecciona una opción</option>
					    {
					      anexos_digitales.map( anexo =>

					          <option key={ Math.random().toString(36).substr(2, 9) } value={anexo.uuid} >
					            {
					              (anexo.idrequisito.requisito)
					            }
					          </option>

					      )
					    }
					  </select>
					  <label htmlFor="floatingSelect">Anexo para visualizar</label>
					</div>


					<br />


					{
					  anexo_visualizar != "" && (
					    <React.Fragment>
					      <object width="100%" height="700px" data={SERVER_+'anexo/'+anexo_visualizar} type="application/pdf">
					          <p>This browser does not support PDFs. Please download the PDF to view it: <a href="filename.pdf">Download PDF</a>.</p>
					      </object>
					    </React.Fragment>
					  )
					}



		        </Modal.Body>
		      </Modal>

			</React.Fragment>

		)

}

export default ModalAnexos